"use client";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { sortByList } from "./helpers";

export const ProductSort = () => {
  const [selectedSort, setSelectedSort] = useState(sortByList[0]);

  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  // Sync from URL on load
  useEffect(() => {
    const sortFromUrl = searchParams.get("sort");

    if (sortFromUrl) {
      const found = sortByList.find((item) => item.value === sortFromUrl);
      if (found) setSelectedSort(found);
    } else {
      setSelectedSort(sortByList[0]); // default
    }
  }, [searchParams]);

const changeSort = (item) => {
  const params = new URLSearchParams(searchParams.toString());

  //If Featured (default) → REMOVE sort بالكامل
  if (!item.sortBy) {
    params.delete("sortBy");
    params.delete("order");
  } else {
    params.set("sortBy", item.sortBy);

    if (item.order) {
      params.set("order", item.order);
    } else {
      params.delete("order");
    }
  }

  const query = params.toString();
  const url = query ? `${pathname}?${query}` : pathname;

  router.push(url);
};

useEffect(() => {
  const sortBy = searchParams.get("sortBy") || "";
  const order = searchParams.get("order") || "";

  const found = sortByList.find(
    (item) =>
      (item.sortBy || "") === sortBy &&
      (item.order || "") === order
  );

  setSelectedSort(found || sortByList[0]); // fallback = Featured
}, [searchParams]);

  const doChange = (e) => {
    setSelectedSort(e.value);
    changeSort(e.value);
  };

  return (
    <Dropdown
      value={selectedSort}
      onChange={doChange}
      options={sortByList}
      optionLabel="name"
      placeholder="Sort By"
    />
  );
};